import { useDeepCompareEffect } from '../../../../../hooks/useDeepCompareEffect';
import { useThroughputTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setThroughputSelectedOutcomes } from '../../../../../store/strategy-store/strategy-store.actions';
import { FiltersListOutcomes } from '../../components/filters-list/filters-list-outcomes';
import { MAX_SELECTION } from '../../initiative-performance.constants';
import { useContributingOutcomes } from '../../initiative-performance.hooks';

export const FiltersOutcomes = () => {
  const contributingOutcomes = useContributingOutcomes();
  const selectedOutcomes = useThroughputTabStore((state) => state.selectedOutcomes);

  useDeepCompareEffect(() => {
    if (contributingOutcomes.length > 0) {
      setThroughputSelectedOutcomes(contributingOutcomes.slice(0, MAX_SELECTION));
    }
  }, [contributingOutcomes]);

  return (
    <FiltersListOutcomes
      outcomes={contributingOutcomes}
      selectedOutcomes={selectedOutcomes}
      onSelectOutcomes={setThroughputSelectedOutcomes}
    />
  );
};
